import mutations from '../mutations';
import api from '../../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    sendEmail({ commit }, payload) {
      commit(mutations.LOADING);
      return api.support
        .sendEmail(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.support
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    createFaq({ commit }, payload) {
      commit(mutations.LOADING);
      return api.support
        .createFaq(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    editFaq({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.support
        .editFaq(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detailFaq({ commit }, id) {
      commit(mutations.LOADING);
      return api.support
        .detailFaq(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    deleteFaq({ commit }, id) {
      commit(mutations.LOADING);
      return api.support
        .deleteFaq(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    faqList({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.support
        .faqList(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {}
};
